import React, { FormEvent, useState } from "react";
import "./NoAccess.scss";

const NoAccess = () => {

  return (
    <div className="widget_info">
      <p className="widget_txt">Widget content can't be displayed. Please contact support.</p>
    </div>
  );
};

export default React.memo(NoAccess);